module.exports = __webpack_public_path__ + "img/SES_220147255.388d0bad.jpg";